import React from 'react';
import { Layout, theme } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useGlobalStore } from '@/stores';

const { Header } = Layout;

/**
 * 顶部导航组件
 */
const HeaderBar: React.FC = () => {
  const { collapsed, toggleCollapsed } = useGlobalStore();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Header style={{ padding: 0, background: colorBgContainer, display: 'flex', alignItems: 'center' }}>
      <div
        onClick={toggleCollapsed}
        style={{
          padding: '0 24px',
          fontSize: '18px',
          cursor: 'pointer',
          transition: 'color 0.3s',
        }}
      >
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </div>
      <div style={{ flex: 1 }} />
      <div style={{ paddingRight: 24 }}>
        <span style={{ color: '#666' }}>WeCom 智能客服中台</span>
      </div>
    </Header>
  );
};

export default HeaderBar;
